import { createRouter, createWebHashHistory } from "vue-router";
const routes = [
  {
    path: "/",
    redirect: "/home",
    component: () => import("@/layout"),
    children: [
      {
        path: 'home',
        name: "home",
        component: () => import(/* webpackChunkName: "about" */ "@/views/home/home.vue"),
      },
      {
        path: 'about',
        name: "about",
        component: () => import(/* webpackChunkName: "about" */ "@/views/about/about.vue"),
      },
      {
        path: 'media',
        name: "media",
        component: () => import(/* webpackChunkName: "media" */ "@/views/media/media.vue"),
      },
      {
        path: 'menu',
        name: "menu",
        component: () => import(/* webpackChunkName: "menu" */ "@/views/menu/menu.vue"),
      },
      {
        path: 'franchise',
        name: "franchise",
        component: () =>
          import(/* webpackChunkName: "franchise" */ "@/views/franchise/franchise.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
